module.exports = __webpack_public_path__ + "static/media/10C.e75f9a99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/10C.svg
// module id = 33
// module chunks = 0